import * as React from 'react';
import { DevicesAction } from '../DevicesNewReducer';
import { ModalWarning } from '../../misc/ModalWarning';
import { ModalFailure } from '../../misc/ModalFailure';

declare const rootUrl: string;

export interface DeviceUnresponsiveProps {

    onClose: () => void;
}

export const DeviceUnresponsive = ({ onClose }: DeviceUnresponsiveProps) => {
    return (
        <>
            <div className="modal-header bg-primary">
                <h3 className="modal-title my-auto">Upload Data</h3>
            </div>
            <div className="modal-body">
                <div className="row">
                    <div className="col-md-12">
                        <h2 className="text-primary text-center">Upload Failed</h2>
                    </div>
                    <ModalFailure>
                        <p>Please try reconnecting the device and running the upload wizard again.</p>
                    </ModalFailure>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <ol className="posh-list">
                            
                            <br></br>
                            <p>If the issue persists, please try the following steps:</p>
                            <li>Safely disconnect the device from the USB port on the PC.</li>
                            <li>Remove the back cover of the device using the screwdriver provided, disconnect any battery pack if present.</li>
                            <li>Reconnect the device to the USB port on the PC.</li>
                            <li>Run the upload wizard again.</li>
                        </ol>
                        </div>      
                    </div>
                
            </div>
            <div className="modal-footer">
                <button className="btn btn-primary btn-outline" onClick={onClose}>Close</button>
            </div>
        </>
    );
}
